import { SessionService } from "src/utils/store-hooks/core/SessionService";
import { SessionConstants } from "src/utils/store-hooks/session-constants";

export const markPendingMainGridScrollPreserve = () => {
  SessionService.setString(
    SessionConstants.PENDING_MAIN_GRID_SCROLL_SYNC_KEY,
    "true",
  );
};

export const consumePendingMainGridScrollPreserve = () => {
  const isPending =
    SessionService.getString(SessionConstants.PENDING_MAIN_GRID_SCROLL_SYNC_KEY) ===
    "true";

  if (isPending) {
    SessionService.remove(SessionConstants.PENDING_MAIN_GRID_SCROLL_SYNC_KEY);
  }

  return isPending;
};